/* ============================================================
   BLANKPILL — Collection / search product-card badges + ordering.
   Adds "Best Seller" (top-sellers collection) and "New"
   (new-arrivals collection) badges to native product cards, and
   orders cards best-seller -> new -> normal via CSS order.
   Self-contained styles. Reversible: remove this file + its tag.
   ============================================================ */

(function () {
  'use strict';
  var path = location.pathname;
  if (!/\/collections\//.test(path) && !/\/search/.test(path) && !/\/products\//.test(path)) return;

  function injectStyle() {
    if (document.getElementById('bp-coll-badge-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-coll-badge-css';
    s.textContent =
      '.bp-coll-badge{position:absolute;top:8px;left:8px;z-index:6;font:800 11px/1 var(--bp-mono,inherit);padding:5px 8px;border-radius:6px;letter-spacing:.04em;text-transform:uppercase;pointer-events:none}' +
      '.bp-coll-badge--bestseller{background:#e8f65c!important;color:#080808!important}' +
      '.bp-coll-badge--new{background:#111!important;color:#fff!important}';
    document.head.appendChild(s);
  }

  function fetchHandles(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { var s = new Set(); (d.products || []).forEach(function (p) { s.add(p.handle); }); return s; })
      .catch(function () { return new Set(); });
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function run(best, news) {
    function tag(card) {
      if (card.__bpColl) return;
      var h = handleOf(card);
      if (!h) return;
      card.__bpColl = 1;

      // Hide the theme's native "Sale" badge — we use Best Seller / New / Pre-Order instead.
      Array.prototype.forEach.call(card.querySelectorAll('span, div, small'), function (el) {
        if (el.children.length === 0 && /^sale$/i.test((el.textContent || '').trim())) {
          var badge = el.closest('[class*="badge" i]') || el;
          badge.style.setProperty('display', 'none', 'important');
        }
      });

      var kind = best.has(h) ? 'bestseller' : (news.has(h) ? 'new' : null);
      // Reorder cards by badge only in grids (collection/search) — not in the product-page recommendations row.
      if (!/\/products\//.test(location.pathname)) {
        var item = card.closest('.product-grid__item, li, .product-grid > *') || card;
        item.style.order = kind === 'bestseller' ? '1' : (kind === 'new' ? '2' : '3');
      }
      if (!kind) return;
      var media = card.querySelector('.product-card__media, .card-gallery, .card__media-wrapper, .card__inner') || card;
      var cs = getComputedStyle(media);
      if (cs.position === 'static') media.style.position = 'relative';
      if (media.querySelector('.bp-coll-badge')) return;
      var b = document.createElement('span');
      b.className = 'bp-coll-badge bp-coll-badge--' + kind;
      b.textContent = kind === 'bestseller' ? 'Best Seller' : 'New';
      // Inline !important — beats the theme card's foreground-color rule.
      b.style.setProperty('color', kind === 'bestseller' ? '#080808' : '#ffffff', 'important');
      b.style.setProperty('background', kind === 'bestseller' ? '#e8f65c' : '#111111', 'important');
      media.appendChild(b);
    }
    function scan() { document.querySelectorAll('product-card, .product-card').forEach(tag); }
    scan();
    [400, 1000, 2000].forEach(function (ms) { setTimeout(scan, ms); });
    try { var mo = new MutationObserver(function () { scan(); }); mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }

  injectStyle();
  Promise.all([fetchHandles('top-sellers'), fetchHandles('new-arrivals')]).then(function (res) {
    run(res[0], res[1]);
  });
})();
